import React from 'react';
import Button from '../button';
import { useDispatch, useSelector } from 'react-redux';
import { handlePlayerInfoOverlay } from 'store/slice/overlaySlice';
import { areArraysEqual, getCookie } from 'utils/commonFunctions';
import config from 'utils/config';

const FooterNav = ({
  selectplayer,
  handleSaveSelection,
  openEvent,
  playersIdFromApi,
  selectedPlayerId
}) => {
  const selectedPlayers = useSelector((state) => state?.createTeam?.selectedPlayers || []);
  const isFinalLock = openEvent?.is_final_locked === 1;
  const dispatch = useDispatch();
  const gameCookie = getCookie(config.gameCookieName);

  return (
    <div className='si-footer__nav'>
      {selectedPlayers.length !== 3 && selectplayer && (
        <Button
          variant='primaryLink'
          transKey='overlay_title_select_players'
          icon='lms-chevron-right'
          classes='si-btn__selectPlayers'
          onClick={() => dispatch(handlePlayerInfoOverlay(true))}
        >
          SELECT PLAYERS
        </Button>
      )}

      {selectedPlayers.length === 3 && !isFinalLock && (
        <Button
          variant='primary'
          transKey={gameCookie?.guid ? 'cta_save_selections' : 'cta_save_selections_and_login'}
          onClick={handleSaveSelection}
          disabled={areArraysEqual(playersIdFromApi, selectedPlayerId)}
        >
          {gameCookie?.guid ? 'Save Selection' : 'Save Selection and Login'}
        </Button>
      )}
    </div>
  );
};

export default FooterNav;
